import axios from "./config";

export const getNotifications = ({ queryStr, params }) => {
  return axios
    .get(`/notifications?${queryStr}`, { params })
    .then((res) => res.data);
};
